import { Typography, Box } from '@mui/material';
import { ReactNode } from 'react';

interface LabelWithDataProps {
  label: string;
  data: string | number;
  icon?: ReactNode;
}

export const LabelWithData = ({ label, data, icon }: LabelWithDataProps) => (
  <Box flex='1 0 0' data-testid='data-collectors-column'>
    <Typography variant='caption'>{label}</Typography>
    <Typography variant='body1' display='flex' alignItems='center'>
      {icon && (
        <Box component='span' mr={1} display='inline-flex'>
          {icon}
        </Box>
      )}
      {data}
    </Typography>
  </Box>
);
